import { IEventData } from 'meta/pages/v4/event'
import { ILocationData } from 'meta/pages/v4/location'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { useEventData } from 'hooks/useEvent'
import { useLocationData } from 'hooks/useLocation'

import WalletTicketMobile from './WalletTicketMobile'
import { WalletTicketMobileSkeleton } from './WalletTicketMobileSkeleton'

type EventProps = {
  onClick: (eventId: number) => void
  isPastEvent?: boolean
  walletEventData: IWalletEvent
  useLongCard: boolean
  eventActive: number
}

type LocationProps = {
  baseProps: EventProps
  eventData: IEventData
}

export type WalletTicketMobileProps = {
  baseProps: EventProps
  eventData: IEventData
  locationData: ILocationData
}

const EventContainer: React.FC<EventProps> = (props) => {
  const { walletEventData, eventActive } = props

  const eventData = useEventData({ idOrCodeUrl: String(walletEventData.id) })

  if (!eventData) {
    return eventActive ? null : <WalletTicketMobileSkeleton />
  }

  return <LocationContainer eventData={eventData} baseProps={props} />
}

const LocationContainer: React.FC<LocationProps> = (props) => {
  const { baseProps, eventData } = props
  const { eventActive } = baseProps

  const locationData = useLocationData({ idOrCodeUrl: String(eventData.locationId) })

  if (!locationData) {
    return eventActive ? null : <WalletTicketMobileSkeleton />
  }

  return <WalletTicketMobile locationData={locationData} eventData={eventData} baseProps={baseProps} />
}

export default EventContainer
